export default {
    pageScroller: "sw-layout-scrollable-element",
};
